<div class="my-2">
  <app-categorybar></app-categorybar>
</div>
<!-- <div class="custombg fixed-top">
  <app-header></app-header>
  <app-breadcrumb></app-breadcrumb>
</div> -->
<div class="top-section d-flex w-100 card">
  <form class="form ">
    <div class="input-align">
      <mat-label>Customer:</mat-label>
      <div class="search-bar mx-1">
        <input type="text" class="form-control" matInput placeholder="Customer" [formControl]="projectInput"
          (input)="getFilteredCustomers($event.target.value)" (onfocus)="getFilteredCustomers('')"
          [matAutocomplete]="customer">
      </div>
      <mat-autocomplete autoActiveFirstOption #customer="matAutocomplete">
        <mat-option *ngFor="let item of customers" (click)="getProjects(item.id)" [id]="item.id" [value]="item.name">
          {{item.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div class="input-align">
      <mat-label>Project:</mat-label>
      <div class="search-bar mx-1">
        <input type="text" class="form-control" matInput placeholder="Projects" [formControl]="projectInputValue"
          (input)="getFilteredProject($event.target.value)" (onfocus)="getFilteredProject('')"
          [matAutocomplete]="project" [disabled]="!clintId">
      </div>
      <mat-autocomplete autoActiveFirstOption #project="matAutocomplete">
        <mat-option *ngFor="let item of projects" (click)="getManagers(item.id)" [id]="item.id" [value]="item.name">
          {{item.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div class="input-align">
      <mat-label>Manager:</mat-label>
      <div class="search-bar mx-1">
        <input type="text" class="form-control" matInput placeholder="Manager" [formControl]="managerInputValue"
          (input)="getFilteredManagers($event.target.value)" (onfocus)="getFilteredManagers('')"
          [matAutocomplete]="manager" [disabled]="!projectId">
      </div>
      <mat-autocomplete autoActiveFirstOption #manager="matAutocomplete">
        <mat-option *ngFor="let item of managers" (click)="onSelectManager(item.id)" [id]="item.id" [value]="item.name">
          {{item.name}}
        </mat-option>
      </mat-autocomplete>
    </div>

    <button type="submit" [disabled]="!showSearchBox" [ngStyle]="{'background-color': showSearchBox ? '' : 'gray' }"
      (click)="onClick()">Search</button>
  </form>

  <app-tech-stack-grid *ngIf="serviceLinesMap.length>0" [serviceLinesMap]="serviceLinesMap" [clintId]="clintId"
    [projectId]="projectId" [managerId]="managerId" [projectData]="projectData" [showGrid]="showGrid">
  </app-tech-stack-grid>
</div>